var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.2,191v-88.2c0-7,5.6-12.6,12.6-12.6s12.6,5.6,12.6,12.6v88.2c0,7-5.6,12.6-12.6,12.6s-12.6-5.6-12.6-12.6h0ZM140.6,191v-88.2c0-7,5.7-12.6,12.6-12.6,7,0,12.6,5.6,12.6,12.6v88.2c0,7-5.7,12.6-12.6,12.6-7,0-12.6-5.6-12.6-12.6Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8,65H27.2c-7,0-12.6-5.6-12.6-12.6s5.6-12.6,12.6-12.6h201.6c7,0,12.6,5.6,12.6,12.6s-5.6,12.6-12.6,12.6h0ZM153.2,27.2h-50.4c-7,0-12.6-5.6-12.6-12.6,0-7,5.6-12.6,12.6-12.6h50.4c7,0,12.6,5.6,12.6,12.6,0,7-5.6,12.6-12.6,12.6ZM52.4,77.6c7,0,12.6,5.6,12.6,12.6v126c0,7,5.6,12.6,12.6,12.6h100.8c7,0,12.6-5.6,12.6-12.6h0v-126c0-7,5.7-12.6,12.6-12.6,7,0,12.6,5.6,12.6,12.6v126c0,20.9-16.9,37.8-37.8,37.8h-100.8c-20.9,0-37.8-16.9-37.8-37.8v-126c0-7,5.6-12.6,12.6-12.6Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.91d9c8b9a42264537846db139022236b.svg";
export { ForwardRef as ReactComponent };